module.exports = __webpack_public_path__ + "img/scan.6856ff5e.svg";